import type { RolePlayResultFragment } from '@/gql/codegen/graphql';
import type React from 'react';
import styles from './index.module.scss';

type Conversation = RolePlayResultFragment['sessionLogs'][number];

export type ConversationProps = {
  logs: Conversation[];
};

export const Conversation: React.FC<ConversationProps> = ({ logs }) => {
  if (logs.length === 0) {
    return null;
  }

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>会話ログ</h3>
      <div className={styles.logContainer}>
        {logs.map((log) => (
          <div
            key={log.id}
            className={
              log.speaker === 'user' ? styles.userMessage : styles.aiMessage
            }
          >
            <div className={styles.messageBubble}>
              <p className={styles.messageContent}>{log.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
